<template>
  <iframe 
    :src="documentationUrl" 
    style="width: 100%; height: 80vh; border: none;"
    title="Документация">
  </iframe>
</template>

<script>
export default {
  name: "Documentation",
  computed: {
    documentationUrl() {
      return process.env.VUE_APP_DOCUMENTATION;
    }
  }
};
</script>

<style scoped>
html, body, #app {
  height: 100%;
  margin: 0;
}
</style>
